export enum TabIds {
  LIST = "article-list-tab",
  GROUP = "groups-tab",
}

export const TabQueryKey = "tab";
